module.exports = __webpack_public_path__ + "static/media/insect(23).6fc9f80e.PNG";